exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container.fixed[data-v-43d1250d]{position:fixed;left:0;right:0;z-index:10;box-shadow:0 3px 6px rgba(0,0,0,.16);transition:transform .6s ease-in-out}.container.fixed.active[data-v-43d1250d]{transform:translateY(100%)}", ""]);

